module.exports = __webpack_public_path__ + "assets/572a61cf1aa972032753571dd0512620.svg";